import { api } from "./client";
import type { components } from "./types";

export type PendingSummary = components["schemas"]["PendingSummary"];
export type PendingSummaryItem = components["schemas"]["PendingSummaryItem"];
export type ApprovalRecord = components["schemas"]["ApprovalRecord"];
export type AuditEntry = components["schemas"]["AuditEntry"];
export type CommitRequest = components["schemas"]["CommitRequest"];

export function getPendingSummary(): Promise<PendingSummary> {
  return api.get<PendingSummary>("/approvals/pending/summary");
}

export interface ListPendingParams {
  project_id?: number;
}

export function listPendingApprovals(params: ListPendingParams = {}): Promise<ApprovalRecord[]> {
  const qs = new URLSearchParams();
  if (params.project_id !== undefined) qs.set("project_id", String(params.project_id));
  const tail = qs.toString();
  return api.get<ApprovalRecord[]>(`/simulations/pending${tail ? `?${tail}` : ""}`);
}

export function getApproval(simulationId: number): Promise<ApprovalRecord> {
  return api.get<ApprovalRecord>(`/simulations/${simulationId}`);
}

export function commitSimulation(simulationId: number, reason: string): Promise<AuditEntry> {
  return api.post<AuditEntry>(`/simulate/${simulationId}/commit`, { reason });
}

export function rejectSimulation(simulationId: number, reason: string): Promise<AuditEntry> {
  return api.post<AuditEntry>(`/simulate/${simulationId}/reject`, { reason });
}
